import React from 'react';
import styles from './filter.module.sass';

type FilterOption = {
  value: string;
  label: string;
};

interface Props {
  data?: FilterOption[];
  minimized?: boolean;
  selectedFilter?: string;
  onUpdate: (string) => void;
}

const LabelFilter = ({ data, minimized, selectedFilter, onUpdate }: Props) => {
  return (
    <div className={styles.filters}>
      <div className={`${styles.wrapper} ${styles.open}`}>
        <nav className={`${styles.list} ${minimized ? styles.minimized : ''}`}>
          {data.map((option, index) => (
            <button
              key={`option-${index}`}
              onClick={() => onUpdate(option.value)}
              className={`${styles.radio} ${
                selectedFilter && selectedFilter === option.value
                  ? styles.selected
                  : ''
              }`}
            >
              {option.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default LabelFilter;
